import CustomerPartNumberReducer from "@tSchaedlerYesco/Store/Data/CustomerPartNumber/CustomerPartNumberReducer";
import CollectNumberReducer from "@tSchaedlerYesco/Store/Data/PlaceOrder/CollectNumberReducer";
import OrderStatusReducer from "@tSchaedlerYesco/Store/Data/PlaceOrder/OrderStatusReducer";
import ReleaseNumberReducer from "@tSchaedlerYesco/Store/Data/PlaceOrder/ReleaseNumberReducer";
import AccountShowProductBrandImagesReducer from "@tSchaedlerYesco/Store/Data/ProductBrandImage/AccountShowProductBrandImagesReducer";
import CustomBrandsSearchReducer from "@tSchaedlerYesco/Store/Reducer/CustomBrandsSearchReducer";
import CustomContentsSearchReducer from "@tSchaedlerYesco/Store/Reducer/CustomContentSearchReducer";
import CustomCategoriesSearchReducer from "@tSchaedlerYesco/Store/Reducer/CustomDocumentsSearchReducer";
import CustomSearchResultTabsReducer from "@tSchaedlerYesco/Store/Reducer/CustomSearchResultTabsReducer";
import { combineReducers } from "redux";

const dataReducers = {
    releaseNumberState: ReleaseNumberReducer,
    orderStatusState: OrderStatusReducer,
    collectNumberState: CollectNumberReducer,
    customerPartNumber: CustomerPartNumberReducer,
    categoriesSearch: CustomCategoriesSearchReducer,
    contentSearch: CustomContentsSearchReducer,
    brandSearch: CustomBrandsSearchReducer,
    searchResultsTab: CustomSearchResultTabsReducer,
    showProductImagesFlag: AccountShowProductBrandImagesReducer,
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);

export default dataReducer;
